import { InjectionToken } from '@angular/core';
import type { Environment } from '../../../environments/environment.interface';

export const APP_CONFIG = new InjectionToken<Environment>('app.config');
